import { render } from "./AreaChartBars.vue?vue&type=template&id=40d31b8a"
import script from "./AreaChartBars.vue?vue&type=script&lang=js"
export * from "./AreaChartBars.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__